import { parseISO } from './model';

const fmt = (locale, opts) => new Intl.DateTimeFormat(locale, { timeZone: 'UTC', ...opts });
const clean = (s) => s.replace(/\./g, '');

export const weekdayShort = (locale, iso) => clean(fmt(locale, { weekday: 'short' }).format(parseISO(iso))).toUpperCase();
export const weekdayLong = (locale, iso) => fmt(locale, { weekday: 'long' }).format(parseISO(iso));
export const dayNum = (iso) => iso.slice(8, 10);
export const monthShort = (locale, iso) => clean(fmt(locale, { month: 'short' }).format(parseISO(iso)));

/** "02 – 08 nov 2026" o "30 nov – 06 dic 2026" */
export function rangeLabel(locale, a, b) {
  const sameMonth = a.slice(0, 7) === b.slice(0, 7);
  const left = sameMonth ? dayNum(a) : `${dayNum(a)} ${monthShort(locale, a)}`;
  return `${left} – ${dayNum(b)} ${monthShort(locale, b)} ${b.slice(0, 4)}`;
}
